import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getEndCalendar = (state: StateScheme) => {
    return state.finance.endCalendar
}
